import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { UserService } from '@services/user.service';
import { Observable, take } from 'rxjs';
import { SessionStorageService } from './storage.service';

@Injectable({
	providedIn: 'root',
})
export class MasterdataService {
	constructor(
		private httpClient: HttpClient,
		private sessionStorageService: SessionStorageService,
		private userService: UserService,
	) {}

	private headers() {
		const accountId: string = this.userService.account.id;
		const token: string = this.sessionStorageService.get('User.Authorization');
		return new HttpHeaders({
			Authorization: `Bearer ${token}`,
			'x-account-id': accountId,
		});
	}

	getRegister(register: string = '', offset: number = 0, engine: string = '1cojbl69l7'): Observable<object> {
		const apiUrl = `${environment.awsEnvUri}/masterdata/stores/engine-${engine}/registers/${register}/items?offset=${offset}`;
		return this.httpClient.get(apiUrl, {
			headers: this.headers(),
		});
	}

	getRegisterRow(register: string = '', item: string, engine: string = '1cojbl69l7'): Observable<object> {
		const apiUrl = `${environment.awsEnvUri}/masterdata/stores/engine-${engine}/registers/${register}/items/${item}`;
		return this.httpClient.get(apiUrl, {
			headers: this.headers(),
		});
	}

	uploadSymbol(fileData, metaData, uploadUrl): Observable<any> {
		console.log('cjs formdata', fileData);
		return this.httpClient.put(uploadUrl, fileData).pipe(take(1));
	}
}
